import { Injectable } from '@angular/core';

import { ClientCachingConfig, PrettyUrlsConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ExpiringCache, ExpiringCacheFactory } from '@frontend/sports/common/core/utils/expiring-cache';
import { LoadingIndicatorService } from '@frontend/vanilla/core';
import { Observable } from 'rxjs';

import { CountIntervalService, IntervalCountsMap, IntervalFilter } from '../../calendar/count-interval.service';

@Injectable({ providedIn: 'root' })
export class CountQuickLinksService {
    private readonly quicklinksCache: ExpiringCache;
    private readonly dayOffset = 24 * 60;

    constructor(
        private indicatorService: LoadingIndicatorService,
        private countIntervalService: CountIntervalService,
        expiringCacheFactory: ExpiringCacheFactory,
        clientCachingConfig: ClientCachingConfig,
        private urlConfig: PrettyUrlsConfig,
        private sitecore: Sitecore,
    ) {
        this.quicklinksCache = expiringCacheFactory.create(clientCachingConfig.quicklinkCountsTimeout);
    }

    getQuicklinkCounts(): Observable<IntervalCountsMap> {
        const indicator = this.indicatorService.start();
        try {
            const intervals = this.getQuicklinkIntervals();

            return this.quicklinksCache.getOrCreate('counts', this.countIntervalService.getCounts(intervals));
        } finally {
            indicator.done();
        }
    }

    private getQuicklinkIntervals(): { [key: string]: IntervalFilter } {
        const { translations } = this.urlConfig;
        const { globalMessages } = this.sitecore;

        return {
            all: { name: translations.all, title: globalMessages.NavAllSports, key: 'all' },
            live: { name: translations.live, title: globalMessages.NavLive, live: true, key: 'live' },
            today: this.countIntervalService.intervalStartOfDay(translations.today, 0, this.dayOffset, globalMessages.NavToday, 'today'),
        };
    }
}
